import React from "react";
import {Popconfirm} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";

export default class TableOperation extends BaseComponent {

    render() {
        const {data, deleteTableItem, showPermissionEdit} = this.props;
        return (
            <>
                <span className="cm-link margin-right-15" onClick={() => showPermissionEdit(data)}>修改</span>
                <Popconfirm
                    title={`确定删除权限：${data.name}`}
                    onConfirm={() => deleteTableItem(data)}
                    okText="确定"
                    cancelText="取消"
                >
                    <span className="cm-link margin-right-15">删除</span>
                </Popconfirm>
            </>
        );
    }


}

